

var ACQ_Banner_Type = 'acquisition';
define(['squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/fi/index', 'components/xo-beaver/dist/logger'], function (squid, template) {

    squid.module('xo-offer.directive', ['squid', 'xomodel.checkout']).directive('xoOffer', function () {
        return {
            template: template,

            scope: {
                token: '=',
                promotion: '=',
                bmlaction: '=',
                installment: '='
            },

            controller: function controller($scope, $FallbackError, $populate, $state, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, $pxp, $logger, $InstallmentOptionsModel, $feature, $locale, $CheckoutPayeeModel, $util, $CreditDataModel, $CreditOptionsModel, $config) {

                $populate($scope, {
                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {
                    $scope.creditTerms = $config.urls.creditTerms;
                    $scope.creditReuseTerms = $config.urls.creditReuseTerms;
                    $scope.bmlOffer = $scope.checkoutSession.bmlOffer;
                    $scope.buyerCountry = $locale.country;
                    var country = $scope.checkoutAppData.merchant.merchant_country;
                    var cart = $scope.checkoutCart;
                    var isRedirectFromCape = $CreditDataModel.instance($scope.token).isRedirectFromCape();
                    var fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments');
                    var merchantId = $scope.payee.getId();
                    $scope.showPPCLogo = false;
                    var isCreditInWallet = $util.find(fundingInstruments, function (fi) {
                        return fi.name === 'BILL_ME_LATER';
                    });

                    if ($feature('creditInstallmentOffers') && country === $locale.country && !cart.isBilling()) {

                        var offers = $InstallmentOptionsModel.instance($scope.token);
                        offers.save({
                            data: {
                                payee: $scope.payee,
                                checkoutCart: $scope.checkoutCart,
                                checkoutAppData: $scope.checkoutAppData,
                                isMemberCredit: true
                            },
                            success: function success(result) {
                                $scope.creditOffers = result.installments && result.installments[0];
                                $scope.installmentCount = $scope.creditOffers && $scope.creditOffers.installment_options && $scope.creditOffers.installment_options.length;
                                $scope.installmentOptionsPresent = $scope.checkoutSession.creditOffer && $scope.installmentCount > 0;
                                $scope.showUKCape = $scope.checkoutAppData.is_second_button_txn || !$feature('blockCreditBanners');
                                $scope.installment.showBanner = showBannerRules();
                                $scope.installment.showCYCO = showCYCORules();
                                $scope.showBml = $scope.installment.showBanner || isRedirectFromCape || $locale.country === 'GB' ? false : $scope.bmlOffer === 1 || $scope.bmlOffer === 2;
                            },
                            contingencies: {
                                DEFAULT: function DEFAULT() {
                                    $logger.info('GET_INSTALLMENT_CONTINGENCY');
                                }
                            }
                        });
                    } else {
                        $scope.showBml = cart.isBillingNoPurchase() || isRedirectFromCape || $locale.country === 'GB' ? false : $scope.bmlOffer === 1 || $scope.bmlOffer === 2;
                    }

                    var showBannerRules = function showBannerRules() {
                        if ($locale.country === 'GB') {
                            $scope.offerTypeKey = $scope.installmentOptionsPresent ? 'offers.bmlInstallmentTitle' : $scope.isBmlOfferSmallOrLarge(ACQ_Banner_Type);
                            return !!($scope.showUKCape && !isCreditInWallet && !isRedirectFromCape && ($scope.bmlOffer === 1 || $scope.bmlOffer === 2 || $scope.checkoutSession.creditOffer));
                        } else {
                            return !isCreditInWallet && $scope.installmentOptionsPresent && !isRedirectFromCape ? true : false;
                        }
                    };

                    var showCYCORules = function showCYCORules() {
                        var commonRules = isCreditInWallet && $scope.checkoutSession.creditOffer && $scope.installmentOptionsPresent;
                        if ($locale.country === 'GB') {
                            return $scope.showUKCape && commonRules;
                        } else {
                            return commonRules;
                        }
                    };

                    $scope.selectExistingBml = function () {

                        var fiList = $scope.checkoutSession.get('fundingOptions.instruments');

                        var fundingSource = $util.find(fiList, function (fi) {
                            return fi.name === 'BILL_ME_LATER';
                        });

                        $scope.checkoutSession.fundingOptions.action('select', {

                            resultModel: $scope.checkoutSession,

                            data: {
                                planId: fundingSource.planId
                            },
                            success: function success(result) {
                                if (result) {
                                    // Update the installments to support the user selecting a card that does not support installments.
                                    $scope.checkoutSession.installments = result.installments;
                                }
                                if (fundingSource.type === 'CREDIT' && $scope.installment.showCYCO) {
                                    $state.go('checkout.chooseCreditOffer');
                                } else {
                                    if (!fundingSource.selected) {
                                        $scope.checkoutSession.message = {
                                            type: 'success',
                                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                                        };
                                        if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
                                            // Resetting selected installment data, if installment change is not explicitly prohibited.
                                            $scope.checkoutSession.selectedInstallmentData = undefined;
                                        }
                                    }
                                    $state.go('checkout.review');
                                }
                            }
                        });
                    };

                    // US693795: Acquisition Banner PXP test
                    var pxpGetAcquisitionBanner = function pxpGetAcquisitionBanner() {
                        var pxpPrefix = 'xo_hermesnodeweb_us_ryi_ppc_';
                        var bannerExperiment = pxpPrefix + 'ppcacquisitionbanner';
                        var treatmentName = '';
                        $scope.pxpCalledAcquisitionBanner = true;
                        $pxp(bannerExperiment, {
                            'ctx.COUNTRY': $locale.country,
                            'ctx.MERCHANT_ID': merchantId
                        }, '(xo_hermesnodeweb_us_ryi_ppc_)(.*)').then(function (result) {
                            if (result && result.treatment_name) {
                                treatmentName = result.treatment_name;
                                $scope.acquisitionBannerTreatmentName = treatmentName;
                                if (treatmentName === pxpPrefix + 'left_logo') {
                                    $scope.showAcquisitionBannerLogo = true;
                                } else if (treatmentName === pxpPrefix + 'OR') {
                                    $scope.showAcquisitionBannerLogo = true;
                                } else if (treatmentName === pxpPrefix + 'contentchange') {
                                    $scope.showAcquisitionBannerLogo = true;
                                    $scope.bmlOfferTitle = $scope.getTransactionAmount() === 0 ? $scope.htmlContent('offers.bmlOfferTitleWithAmountZero') : $scope.getBmlOfferTitle('WithAmount', {
                                        cartAmount: $scope.checkoutCart.get('purchase.amounts.total.amount_formatted')
                                    });
                                } else if (treatmentName === pxpPrefix + 'right_logo') {
                                    $scope.showAcquisitionBannerLogo = true;
                                } else {
                                    $scope.showAcquisitionBannerLogo = false;
                                }
                            }
                        }, function () {
                            $scope.pxpCalledAcquisitionBanner = false;
                        });
                    };

                    // US693795: Acquisition Banner PXP test
                    $scope.getBmlOfferTitle = function (suffix, data) {
                        if ($scope.bmlOffer === 1) {
                            return $scope.htmlContent('offers.bmlOfferLargeTitle' + suffix, data);
                        } else if ($scope.bmlOffer === 2) {
                            return $scope.htmlContent('offers.bmlOfferSmallTitle' + suffix, data);
                        } else {
                            return '';
                        }
                    };

                    // US693795: Acquisition Banner PXP test
                    $scope.showAcquisitionBanner = function () {
                        if ($scope.showBml && $scope.buyerCountry === 'US' && !$scope.pxpCalledAcquisitionBanner) {
                            // override bmlOffer
                            if ($scope.isBmlOfferLarge()) {
                                $scope.bmlOffer = 1;
                            } else {
                                $scope.bmlOffer = 2;
                            }
                            $scope.bmlOfferTitle = $scope.getBmlOfferTitle('');
                            pxpGetAcquisitionBanner();
                        }
                        return $scope.showBml && $scope.buyerCountry !== 'GB';
                    };

                    /**
                     * Only show PPC Reuse banner if
                     * Country is US & Credit is not default AND There is credit in wallet AND pxp variant has banner
                     **/
                    $scope.showReuseBanner = function () {
                        $scope.isCreditDefault = $scope.checkoutSession.get('plan.paypal_credit');
                        var reuseRules = isCreditInWallet && !$scope.isCreditDefault;
                        $scope.installment.showRepresentativeInfo = $scope.showUKCape && $locale.country === 'GB' && (reuseRules || $scope.installment.showBanner);
                        $scope.showPPCLogo = true;

                        if ($locale.country === 'US' && reuseRules) {
                            return true;
                        } else if ($scope.showUKCape && $locale.country === 'GB' && reuseRules) {
                            $scope.reuseOfferTypeKey = $scope.installmentOptionsPresent ? 'offers.bmlExistingOfferInstallment' : $scope.isBmlOfferSmallOrLarge();
                            return true;
                        }
                        return false;
                    };

                    /**
                     * This function is to determine that the offer is large offer (transaction amount >= 99) or
                     * smaller (transaction amount < 99) to display appropriate text on ui
                     * @returns bmlExistingSmall/LargeOffer
                     */
                    $scope.isBmlOfferSmallOrLarge = function (bannerType) {
                        var key;
                        if ($scope.isBmlOfferLarge()) {
                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferLargeTitle' : 'offers.bmlExistingOfferLarge';
                        } else {
                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferSmallTitle' : 'offers.bmlExistingOfferSmall';
                        }
                        return key;
                    };

                    // US693795: Acquisition Banner PXP test
                    // small refactor of isBmlOfferSmallOrLarge() function
                    $scope.isBmlOfferLarge = function () {
                        var transactionAmount = $scope.getTransactionAmount();
                        var sacEligibleAmount = $CreditOptionsModel.sacEligibleAmount[$locale.country];
                        return transactionAmount >= sacEligibleAmount;
                    };

                    // US693795: Acquisition Banner PXP test
                    $scope.getTransactionAmount = function () {
                        var transactionAmount = $scope.checkoutCart.get('purchase.amounts.total.amount');
                        return parseFloat(transactionAmount) || 0;
                    };

                    $scope.bml = function () {
                        $state.go('checkout.redirectToCape');
                    };

                    $scope.creditOffer = function () {
                        $state.go('checkout.chooseCreditOffer');
                    };

                    $scope.addPlcc = function () {
                        $scope.promotion.type = 'plcc';
                        $state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
                    };

                    $scope.showPlcc = $scope.checkoutSession.plccOffer;
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/offer/directive.js
// module id = ./components/xo-credit-components/src/offer/directive.js
// module chunks = 1